import React from "react";
import { object } from "prop-types";
import get from "lodash/get";

import "./collection-widget.m.css";

const customContent = `<!DOCTYPE html> <html lang="en"> <head>   <meta charset="UTF-8">   <meta name="viewport" content="width=device-width, initial-scale=1.0">    <style>     .responsive-widget {       display: flex;       flex-wrap: wrap;       margin: 0 auto;       width: 100%;      }  .responsive-widget h3  {     font-family: 'Playfair Display';     text-align: center;     display: flex;     margin:20px auto 0 auto;     font-size: 24px; }     .responsive-iframe12 {  border: 0px solid #ddd;  } .responsive-iframe12 { flex:0 0 100%;  height: 360px; }       /* Adjust these media queries for different screen sizes if needed */     @media (max-width: 768px) {      .responsive-iframe12  {     flex: 0 0 100%;     height: 600px; }        }   </style> </head> <body>   <div class="responsive-widget">   <h3>ದೆಹಲಿ ಚುನಾವಣೆ ಫಲಿತಾಂಶ 2025</h3>     <iframe src="https://d3ifa25g607lxt.cloudfront.net/main/delhi-assembly-2025.html" class="responsive-iframe12" ></iframe>        </div> </body> </html>`;
const CollectionWidget = ({ collection, isCustomContent = false }) => {
  const content = isCustomContent ? customContent : get(collection, ["associated-metadata", "content"], "");

  return <div styleName="wrapper" dangerouslySetInnerHTML={{ __html: content }}></div>;
};

CollectionWidget.propTypes = {
  collection: object
};

export default CollectionWidget;
